/* prettier-ignore */

import { CommonModule } from '@angular/common';
import { Component, CUSTOM_ELEMENTS_SCHEMA, inject, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { UserService } from 'src/app/services/user.service';
import { PopUp } from '../interfaces/passport.interface';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: "app-passport-popup",
  imports: [
    CommonModule,
    TranslateModule,
    
  ],  
  standalone: true,
  templateUrl: "./popup.component.html",
  styleUrls: ["./popup.component.scss"],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})

export class PassportPopUpComponent {
  @Input("popUp") popUp: PopUp;

  private userService = inject(UserService);  
  private modalController = inject(ModalController);
  private cookieService = inject(CookieService);
  public translate = inject(TranslateService);
  private _sanitizer = inject(DomSanitizer);

  goToLogin(){
    this.modalController.dismiss().then(() => {
      this.setCookie();
      this.userService.login();
    })
  }

  closeModal(){
    this.setCookie();
    this.modalController.dismiss(); 
  }

  setCookie(){
    this.cookieService.set('passport-viewed', 'true');
  }
  
  getSanitizedDescription(): SafeHtml {
    return this._sanitizer.bypassSecurityTrustHtml(this.popUp?.description?.[this.translate.currentLang] || '');
  }
}
